import { useState, type InputHTMLAttributes } from 'react';

const baseClass =
  'w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed';

export function SignInInput(props: InputHTMLAttributes<HTMLInputElement>) {
  const isPassword = props.type === 'password';
  const [revealed, setRevealed] = useState(false);

  if (!isPassword) {
    return (
      <input
        data-testid={`signInInput-${props.type}`}
        {...props}
        className={baseClass}
      />
    );
  }

  return (
    <div className="relative">
      <input
        data-testid={`signInInput-${props.type}`}
        {...props}
        type={revealed ? 'text' : 'password'}
        className={`${baseClass} pr-10`}
      />
      <button
        type="button"
        onClick={() => setRevealed((v) => !v)}
        disabled={props.disabled}
        tabIndex={-1}
        aria-label={revealed ? 'Hide password' : 'Show password'}
        aria-pressed={revealed}
        data-testid="signInInput-password-toggle"
        className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center text-gray-500 hover:text-gray-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {revealed ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
            <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
            <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
            <line x1="2" y1="2" x2="22" y2="22" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}
